import { REGEX } from "@/backend/lib/regex";
import { Parameter } from "@/backend/models/parameter";
import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";

export const findReferencedParameters = (content: string, parameters: Parameter[]) => {
  const matches = [...content.matchAll(REGEX.PARAMETER_IDENTIFIER)].flat();
  for (let i = 0; i < matches.length; i+=1) {
    const match = matches[i];
    const sanitizedMatch = match.replace(/<<|>>/g, '').split('.');
    const parameter = parameters.find(param => param.identifier === sanitizedMatch[0]);
    if (!parameter) {
      return { error: I18n.get('invalidInputReference', { match: sanitizedMatch[0] }), foundIdentifier: sanitizedMatch[0] };
    }
    if (sanitizedMatch.length > 1 && sanitizedMatch[1] !== '') {
      if (parameter.fieldType === CUSTOM_FIELD_TYPES.Object) {
        const object = parameter.propertyKeys.find(property => property.key === sanitizedMatch[1]);
        if (!object) {
          return { error: I18n.get('invalidParameterObjectReference', { type: I18n.get(parameter.type), match: sanitizedMatch[0], key: sanitizedMatch[1] }), foundIdentifier: sanitizedMatch[0] };
        }
      } else {
        return { error: I18n.get('parameterNotObject', { type: I18n.get(parameter.type), match: sanitizedMatch[0] }), foundIdentifier: sanitizedMatch[0] };
      }
    }
  }

  return null;
};

export const parseReferences = (content: string, parameters: Parameter[]) => {
  const result = findReferencedParameters(content, parameters);
  if (result) return result.error;
  return null;
};

export function resize(elementId: string) {
  const text = document.getElementById(elementId) as HTMLTextAreaElement;
  if (!text) {return;}
  text.style.height = 'auto';
  const scrollHeight = text.scrollHeight + 5;
  text.style.height = `${scrollHeight}px`;
}